export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
} 

export const formatDateShort = (date) => {
    return new Date(date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
} 

export const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export const formatDuration = (totalSecs, includeHours = true) => {
    const {hours, mins, secs} = getTimeParts(totalSecs);
    return (includeHours ? hours.toString().padStart(2, '0') + ":" : '') + mins.toString().padStart(2, '0') + ":" + secs.toString().padStart(2, '0');
}

const getTimeParts = (totalSecs) => {                    
    const hours = parseInt(totalSecs / 3600);
    totalSecs =  totalSecs % 3600;
    const mins = parseInt(totalSecs/60, 10);
    const secs = parseInt(totalSecs % 60);
    return { hours, mins, secs};
}